/**
 *  @class
 *  @function ImageTextOverlay
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (this.tl && typeof this.tl.kill === 'function') {
        this.tl.kill();
      }
      if (this.splittext && typeof this.splittext.revert === 'function') {
        this.splittext.revert();
      }
    }
    revealOverlayCopy() {
      this.querySelectorAll('.image-with-text-overlay--heading, .rte p').forEach((el) => {
        el.style.visibility = 'visible';
      });
      this.querySelectorAll('.subheading, .button, .inline-badge').forEach((el) => {
        el.style.opacity = '1';
        el.style.visibility = 'visible';
      });
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      const startTimeline = () => {
        if (section._overlayAnimStarted) {
          return;
        }
        section._overlayAnimStarted = true;

        try {
          const splitTargets = section.querySelectorAll('.image-with-text-overlay--heading, p:not(.subheading)');
          if (splitTargets.length && typeof SplitText !== 'undefined') {
            section.splittext = new SplitText(splitTargets, {
              type: 'lines, words',
              linesClass: 'line-child'
            });
          }
        } catch (err) {
          section.splittext = false;
        }

        section.tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top 80%"
          }
        });

        if (section.querySelector('.inline-badge')) {
          section.tl
            .fromTo(section.querySelector('.inline-badge'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 1
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.image-with-text-overlay--heading')) {
          const headingLines = section.querySelectorAll('.image-with-text-overlay--heading .line-child div');
          section.tl.set(section.querySelector('.image-with-text-overlay--heading'), {
            visibility: 'visible'
          }, 0);
          if (headingLines.length) {
            let h3_duration = 0.8 + ((headingLines.length - 1) * 0.08);
            section.tl.from(headingLines, {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
            button_offset += h3_duration;
          }
        }
        if (section.querySelector('.rte p')) {
          const textLines = section.querySelectorAll('.rte p .line-child div');
          section.tl.set(section.querySelectorAll('.rte p'), {
            visibility: 'visible'
          }, 0);
          if (textLines.length) {
            let p_duration = 0.8 + ((textLines.length - 1) * 0.02);
            section.tl.from(textLines, {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0);
            button_offset += p_duration;
          }
        }
        if (section.querySelectorAll('.button').length) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }

        if (!section.splittext) {
          section.revealOverlayCopy();
        }
      };

      const fontsReady = (document.fonts && document.fonts.ready)
        ? document.fonts.ready
        : Promise.resolve();
      const timeout = new Promise((resolve) => {
        setTimeout(resolve, 500);
      });

      Promise.race([fontsReady, timeout]).then(startTimeline).catch(() => {
        section.revealOverlayCopy();
      });

      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }
    }
  }
  customElements.define('image-with-text-overlay', ImageTextOverlay);
}
